import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UserSettingsService } from '@user-settings/services/user-settings.service';


/**
 * When applied to a route with a data.addOn property
 * will check that the addon is enabled, if not the user
 * will be routed to not-licensed, otherwise the route will continue
 * This is client side only and does not replace the server side license checks
 */
@Injectable()
export class AddOnGuard  {

  constructor(
    private readonly router: Router,
    private readonly userSettings: UserSettingsService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const dataAddOn = route.data['addOn'] as string;

    return this.userSettings.getUserSettings().pipe(map(us => {

      if (dataAddOn === undefined) {
        console.warn('AddOnGuard applied but no addOn was specified in route data');
      }

      const isAllowed = us.EnabledAddOns.includes(dataAddOn);

      if (isAllowed) {
        return true;
      } else {
        this.router.navigate(['/not-licensed']);
        return false;
      }
    }));
  }
}
